<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>KESEJAHTERAAN</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Kesejahteraan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Kesejahteraan </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              placeholder="Jenis Kesejahteraan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nama.$error}">
            <label> Nama </label>
            <j-input
              v-model="$v.data_master.nama.$model"
              placeholder="Nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.penyelenggara.$error}">
            <label> Penyelenggara </label>
            <j-input
              v-model="$v.data_master.penyelenggara.$model"
              placeholder="Penyelenggara"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.dari_tahun.$error}">
            <label> Dari Tahun </label>
            <j-input
              v-model="$v.data_master.dari_tahun.$model"
              type="number"
              placeholder="Dari Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sampai_tahun.$error}">
            <label> Sampai Tahun </label>
            <j-input
              v-model="$v.data_master.sampai_tahun.$model"
              type="number"
              placeholder="Sampai Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
            <label> Status </label>
            <j-input
              v-model="$v.data_master.status.$model"
              placeholder="Status"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Kesejahteraan</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Kesejahteraan </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              :disabled="readOnly"
              placeholder="Jenis Kesejahteraan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nama.$error}">
            <label> Nama </label>
            <j-input
              v-model="$v.data_master.nama.$model"
              :disabled="readOnly"
              placeholder="Nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.penyelenggara.$error}">
            <label> Penyelenggara </label>
            <j-input
              v-model="$v.data_master.penyelenggara.$model"
              :disabled="readOnly"
              placeholder="Penyelenggara"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.dari_tahun.$error}">
            <label> Dari Tahun </label>
            <j-input
              v-model="$v.data_master.dari_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Dari Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.sampai_tahun.$error}">
            <label> Sampai Tahun </label>
            <j-input
              v-model="$v.data_master.sampai_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Sampai Tahun"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
            <label> Status </label>
            <j-input
              v-model="$v.data_master.status.$model"
              :disabled="readOnly"
              placeholder="Status"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jKesejahteraan',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jenis', 'nama', 'penyelenggara', 'dari_tahun', 'sampai_tahun', 'status'],
      options: {
        headings: {
          jenis: 'JENIS KESEJAHTERAAN',
          nama: 'NAMA',
          penyelenggara: 'PENYELENGGARA',
          dari_tahun: 'DARI TAHUN',
          sampai_tahun: 'SAMPAI TAHUN',
          status: 'STATUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jenis', 'nama', 'penyelenggara', 'dari_tahun', 'sampai_tahun', 'status'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListKesejahteraan(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jenis: '',
        nama: '',
        penyelenggara: '',
        dari_tahun: null,
        sampai_tahun: null,
        status: '',
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createKesejahteraan', 'updateKesejahteraan', 'deleteKesejahteraan']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        nama: '',
        penyelenggara: '',
        dari_tahun: null,
        sampai_tahun: null,
        status: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        nama: '',
        penyelenggara: '',
        dari_tahun: null,
        sampai_tahun: null,
        status: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jenis: param.row.jenis,
        nama: param.row.nama,
        penyelenggara: param.row.penyelenggara,
        dari_tahun: param.row.dari_tahun,
        sampai_tahun: param.row.sampai_tahun,
        status: param.row.status,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createKesejahteraan(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateKesejahteraan(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteKesejahteraan(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jenis: { required },
        nama: { required },
        penyelenggara: { required },
        dari_tahun: { required },
        sampai_tahun: { required },
        status: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jKesejahteraan.vue